import React from 'react';

import { List, Item, Info } from './styles';

interface Props {
  list: Array<{
    icon: any;
    name: string;
    detail: string;
    show: boolean;
    onClick: (event: React.SyntheticEvent) => void;
  }>;
}

export const NavigationList = ({ list }: Props) => (
  <List>
    {list.map(
      ({ icon, name, detail, show, onClick }) =>
        show && (
          <Item key={name} onClick={onClick}>
            <Item.Icon>{icon}</Item.Icon>
            <Info>
              <Item.Name>{name}</Item.Name>
              <Item.Detail>{detail}</Item.Detail>
            </Info>
          </Item>
        ),
    )}
  </List>
);

export default NavigationList;
